<i18n>
{
	"en": {
		"events": "No events | {count}/{totalCount} Events"
	},
	"no": {
		"events": "Ingen hendelser | {count}/{totalCount} Hendelser"
	}
}
</i18n>
<template>
	<div class="map-container">
		<t-panel-header
			class="map-header"
			:text="$tc('events', count<=0, {count, totalCount})"
			icon="map-marker"
			type="bp"
			size="md"
		/>
		<t-map v-if="ready" :bounds="getBounds()" :animate="false">
			<t-marker-collection
				:items="items"
				:iconGetter="getIcon"
			/>
		</t-map>
	</div>
</template>

<script>
import L from 'leaflet';

export default {
	name: 'LogMap',
	props: {
		ready: Boolean,
		orderEvents: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		map() {
			let OPEN_SOURCE_MUST_CHANGE = { osm: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png' };
			return L.tileLayer(OPEN_SOURCE_MUST_CHANGE.osm, { attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors', });
		},
		items() {
			return this.orderEvents.filter(x => x.latitude && x.longitude);
		},
		totalCount() {
			return this.orderEvents.length;
		},
		count() {
			return this.items.length;
		},
	},
	methods: {
		getIcon(item) {
			switch (item.type) {
			case 'loaded':
				return { iconName: 'pickup', iconType: 'tim', iconSize: 1.1, iconOffset: [ 0, 2 ] };
			case 'unloaded':
				return { iconName: 'delivery', iconType: 'tim', iconSize: 1.1, iconOffset: [ 0, 2 ] };
			default:
				return { iconName: 'map-marker', iconType: 'bp' };
			}
		},
		getBounds() {
			return this.items.map(x => [ x.latitude, x.longitude ]);
		}
	}
};
</script>

<style lang="scss" scoped>
.map-container {
	display: flex;
	flex-direction: column;
	height: 400px;
}

.map-header {
	padding: 15px;
	background: white;
}
</style>
